import { Container } from "./Container/Container";
import { CFlexContainer } from "./Container/CFlexContainer";
import { Div } from "./Div";
import { Tag } from "./Tag";
import { Section as TBoxSection } from "./Box/TBox/Section";
import { TextBox } from "./Box/TextBox";
import { toMap } from "../../../HA";

// ─── Slots anti-TDZ pour les sous-classes de Page (ha/442) ───────────────────
// ArticlePage et ResultListPage étendent Page → import direct = TDZ cycle.
let _ArticlePageCtor: any = class { protected createSelf() {} };
let _ResultListPageCtor: any = class { protected createSelf() {} };
export function registerArticlePage(ctor: any): void { _ArticlePageCtor = ctor; }
export function registerResultListPage(ctor: any): void { _ResultListPageCtor = ctor; }

export class Page extends Container {

    public static createNewByType(data: Map<any, any>, main: Tag) {
        return (new Page()).createByType(data, main);
    }

    protected createByType(data: Map<any, any>, main: Tag) {
        const t = data.get("t");
        let tag: any = null;
        switch (t) {
            case "m":
                main.appendChild(new Div(data));
                return;
            case "pa-a":
                tag = new _ArticlePageCtor(data);
                break;
            case "pa-s":
                tag = new Page(data);
                break;
            case "pa-m":
            case "pa-rlp":
                tag = new _ResultListPageCtor(data);
                break;
            case "s":
                tag = new TBoxSection({ d: data.get("d") });
                break;
            case "tb":
                tag = new TextBox({ tdata: data.get("d") });
                break;
            default:
                super.createByType(data, main);
                break;
        }

        if (tag) {
            main.appendChild(tag);
        }
    }

    protected initialize(data: any) {
        super.initialize(data);
        this.addAttribute("tt", "pa");
        this.addClass("pages");
    }

    protected createSelf() {
        super.createSelf();
        const c = new CFlexContainer({ class: "pa-cont" });
        const tdata = this.get("d");
        const trans = this.get("trans");
        if (tdata) {
            this.replaceValues(tdata);
            tdata.forEach((item: any) => {
                if (!item) { return; }
                const nitem = toMap(item);
                if (trans) { (nitem as any).set("trans", trans); }
                this.createByType(nitem as Map<any, any>, c);
            });
        }

        this.appendChild(c);
    }
}
